var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleYellowVourcher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#FFB61E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 13H21V19H11V13ZM23 10C24.0938 10 25 10.9062 25 12V14.5C24.1562 14.5 23.5 15.1875 23.5 16C23.5 16.8438 24.1562 17.5 25 17.5V20C25 21.125 24.0938 22 23 22H9C7.875 22 7 21.125 7 20V17.5C7.8125 17.5 8.5 16.8438 8.5 16C8.5 15.1875 7.8125 14.5 7 14.5V12C7 10.9062 7.875 10 9 10H23ZM10 19C10 19.5625 10.4375 20 11 20H21C21.5312 20 22 19.5625 22 19V13C22 12.4688 21.5312 12 21 12H11C10.4375 12 10 12.4688 10 13V19Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleYellowVourcher);
export default __webpack_public_path__ + "static/media/circle-yellow-vourcher.f67462bbd9137a54cc1ef4af6eb75e97.svg";
export { ForwardRef as ReactComponent };